import { Text } from 'react-native-paper'

export default function MapPage() {
    return <Text style={{ fontSize: 20 }}>Map page is under construction</Text>
}
